module.exports = __webpack_public_path__ + "static/Kora-8d9c1811090c4bd951fb476085191f46.jpg";